import type { KottiField } from '../kotti-field/types'

export const KOTTI_FIELD_TOGGLE_SUPPORTS: KottiField.Supports = {
	autoComplete: false,
	borderless: false,
	clear: false,
	decoration: false,
	placeholder: false,
	tabIndex: true,
}
